import { IRecipeStepEditable, StepMode } from '../../types/recipes-types';
import { getMinutesDuration } from '../../utils/minutes.parser';

export const getMinuteLabel = (count: number): string => {
  return count === 1 ? 'minute' : 'minutes';
};

const floatTo2DigigtAfterDot = (num: number): number => {
  return Math.round(num * 100) / 100;
};

export const generateStepName = (item: IRecipeStepEditable) => {
  const units = item.isCelsius ? 'C' : 'F';
  if (item.mode === StepMode.Rate) {
    return `${item.mode} ${floatTo2DigigtAfterDot(item.heatingRate)} ${units}/h to ${floatTo2DigigtAfterDot(
      item.heatingLimit,
    )} ${units}`;
  }

  const minutes = getMinutesDuration(item.durationDays, item.durationHours, item.durationMinutes);

  return `${item.mode} ${minutes} ${getMinuteLabel(minutes)}`;
};
